import { defineMessages } from 'react-intl';

import { MORTGAGE_EXTENDED_RATE_TYPES } from './MortgageRateTypes';


export default defineMessages({
    [MORTGAGE_EXTENDED_RATE_TYPES.FIXED]: {
        id: 'Mortgages.rateTypes.fixed',
        defaultMessage: 'Fixed',
    },
    [MORTGAGE_EXTENDED_RATE_TYPES.VARIABLE]: {
        id: 'Mortgages.rateTypes.variable',
        defaultMessage: 'Variable',
    },
    [MORTGAGE_EXTENDED_RATE_TYPES.FIXED_OPEN]: {
        id: 'Mortgages.rateTypes.rateTypes.fixedOpen',
        defaultMessage: 'Fixed - Open',
    },
    [MORTGAGE_EXTENDED_RATE_TYPES.VARIABLE_OPEN]: {
        id: 'Mortgages.rateTypes.rateTypes.variable-open',
        defaultMessage: 'Variable - Open',
    },
    [MORTGAGE_EXTENDED_RATE_TYPES.CASHBACK]: {
        id: 'Mortgages.rateTypes.rateTypes.cashback',
        defaultMessage: 'Cash Back',
    },
});
